import React, { useCallback, useMemo } from 'react';
import { Radio, RadioGroup } from 'rsuite';
import { ValueType } from 'rsuite/esm/Radio';
import { ExpressRegistrationRegistrant } from 'src/types/configuration';
import { REGISTRANT_OPTIONS } from 'src/types/flow';

interface RegistrantRadioGroupProps {
  configuration: ExpressRegistrationRegistrant;
  value?: REGISTRANT_OPTIONS;
  onChange?: (value: REGISTRANT_OPTIONS) => void;
  disabled?: boolean;
  ariaDescribedBy?: string;
  ariaInvalid?: boolean;
}

const SIMPLE_PROPERTY_MANAGER_LABEL = 'No, I am a property manager';
const INDEPENDENT_PROPERTY_MANAGER_LABEL =
  "No, I'm an independent property manager";
const COMPANY_PROPERTY_MANAGER_LABEL =
  'No, I work for a property manager company';
const TENANT_LABEL = 'No, I am a tenant';
const OWNER_LABEL = "Yes, I'm the owner";

export const RegistrantRadioGroup = ({
  value,
  onChange,
  configuration,
  disabled,
  ariaDescribedBy,
  ariaInvalid,
}: RegistrantRadioGroupProps) => {
  const handleRadioGroupChange = useCallback(
    (value: ValueType) => {
      if (onChange) {
        onChange(value as REGISTRANT_OPTIONS);
      }
    },
    [onChange]
  );

  const propertyManagerLabel = useMemo(() => {
    if (configuration.property_manager_independent) {
      return COMPANY_PROPERTY_MANAGER_LABEL;
    }
    return SIMPLE_PROPERTY_MANAGER_LABEL;
  }, [configuration]);
  return (
    <RadioGroup
      name="radio-option-group"
      value={value}
      onChange={handleRadioGroupChange}
      disabled={disabled}
      aria-describedby={ariaDescribedBy}
      aria-invalid={ariaInvalid || undefined}
    >
      {configuration?.property_owner && (
        <Radio value={REGISTRANT_OPTIONS.OWNER}>{OWNER_LABEL}</Radio>
      )}
      {configuration?.property_manager && (
        <Radio value={REGISTRANT_OPTIONS.PROPERTY_MANAGER}>
          {propertyManagerLabel}
        </Radio>
      )}
      {configuration?.property_manager_independent && (
        <Radio value={REGISTRANT_OPTIONS.PROPERTY_MANAGER_INDEPENDENT}>
          {INDEPENDENT_PROPERTY_MANAGER_LABEL}
        </Radio>
      )}
      {configuration?.tenant && (
        <Radio value={REGISTRANT_OPTIONS.TENANT}> {TENANT_LABEL}</Radio>
      )}
    </RadioGroup>
  );
};
